const initialvalues = {
    paymentlogin: "",
    setOwnerDetailsbyRadiologin: [],
    setfilterOwnerDetailsbyRadiologin: [],
    setDueDetailslogin: [],
    bakFlaglogin: false,
    backFlag1login: "fresh",
    formikValueslogin: {}
}
    

export default function LoginPaymentReducer(details = initialvalues, action) {

    switch (action.type) {
        case "PAYMENTLOGIN":
            return { ...details, paymentlogin: action.payload };

        case "SETOWNERDETAILSBYRADIOLOGIN":
            return { ...details, setOwnerDetailsbyRadiologin: action.payload };
        case "SETFILTEROWNERDETAILSBYRADIOLOGIN":
            return { ...details, setfilterOwnerDetailsbyRadiologin: action.payload };
        case "SETDUEDETAILSLOGIN":
            return { ...details, setDueDetailslogin: action.payload };

        case "FORMIKVALUESLOGIN":
            return { ...details, formikValueslogin: action.payload };
        case "BACKFLAGLOGIN":
            return { ...details, bakFlaglogin: action.payload };
        case "BACKFLAG1LOGIN":
            return { ...details, backFlag1login: action.payload };

        default:
            return details;
    }
}